import { render } from "./CustomerFilterForm.vue?vue&type=template&id=66737d02&scoped=true"
import script from "./CustomerFilterForm.vue?vue&type=script&lang=js"
export * from "./CustomerFilterForm.vue?vue&type=script&lang=js"

import "./CustomerFilterForm.vue?vue&type=style&index=0&id=66737d02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66737d02"

export default script